

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { Service } from './service';

export interface MachineLabTestConfigParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface MachineLabTestConfig {
    id?: any;
    tenantId: any;
    branchId: any;
    
    serviceId:any;
    unitId:any;
    labCategoryId:any;

    defaultValue:string;

    commonMinValue:number;
    commonMaxValue:number;
    childrenMinValue:number;
    childrenMaxValue:number;
    maleMinValue:number;
    maleMaxValue:number;
    femaleMinValue:number;
    femaleMaxValue:number;
    othersMinValue:string;
    othersMaxValue:string;
    isActive:string;
    labTestMethodId?:any;
    labTestMaterialId?:any;
    
    parameters?: MachineLabTestConfigParameter[];
    links?: any;
    service?:Service;
    labTestMethod?:any;
    labTestMaterial?:any;
    outsideLabId?:any;
    machineCode?:any;
    globalTestCode?:any;
    machineTestCode?:any;

}


export abstract class MachineLabTestConfigData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<MachineLabTestConfig[]>;
    // abstract create(url: string, data: LabTest): Observable<LabTest[]>;
    // abstract update(url: string, data: LabTest): Observable<LabTest>;
    // abstract delete(url: string): Observable<any>;
}
